import React from 'react'
import withStyles from '@mui/styles/withStyles'
import { Chip } from '@mui/material'
import TitleHeader from '../../../../../../../smallComponents/Header'
import i18next from 'i18next'

const styles = () => ({
  wrapper: {
    fontSize: 15,
    fontWeight: 500,
    padding: 10,
    margin: 10,
    borderRadius: 10,
    background: 'rgba(217,224,252, 0.1)',
    fontStyle: 'oblique',
  },
})

const ModelTags = ({ DCGProps, model, classes }) => {
  const { isDarkModeActive } = DCGProps
  const lang = i18next.language
  const rtl = lang === 'ar'
  return (
    <>
      <TitleHeader
        headerText={rtl ? 'مختصرات النموذج' : 'Model Tags'}
        subHeaderText={
          rtl ? 'تعرّف على النموذج سريعا' : 'Quickly Identify the Model'
        }
      />
      <article className={classes.wrapper}>
        <section
          style={{ display: 'flex', flexFlow: 'row wrap', width: '100%' }}
        >
          {model?.tags?.map((tag, idnex) => (
            <Chip
              key={idnex}
              label={tag}
              style={{
                color: isDarkModeActive ? 'white' : null,
                fontSize: 12,
                margin: '2px',
                fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
              }}
            />
          ))}
        </section>
      </article>
    </>
  )
}

const WrappedModelTags = withStyles(styles)(ModelTags)

export default WrappedModelTags
